<!-- 联系HR -->
<template>
	<div class="wrap">

		<div class="header">
			<img src="../assets/return.png" class="return-img" @click="$router.back()">
			<p class="header-title">联系HR</p>
		</div>

		<div class="box">
			<img src="../assets/code.png" class="code-img">
			<span class="msg blue"><img src="../assets/icon-54.png" class="icon">电话： 15959447998</span>
			<span class="msg">邮箱：support@gyxqcdz.com</span>
			<button type="button" class="btn">联系HR</button>
		</div>

		<div class="box">
			<img src="../assets/code.png" class="code-img">
			<span class="msg">邮箱：support@gyxqcdz.com</span>
			<button type="button" class="btn">联系GYXQCDZ</button>
		</div>

		<!-- 联系-拨打弹窗 -->
		<div class="mask-layer"></div>
		<div class="window">
			<p class="window-title">拨打电话</p>
			<p class="window-msg">您确定拨打：159 5944 7998</p>
			<div class="window-btn-box">
				<button type="button" class="border-btn">取消</button>
				<button type="button">确定拨打</button>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {

			};
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 74px 37px 37px;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header {
		width: 100%;
		height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		position: fixed;
		top: 0;
		left: 0;
		background-color: #FFFFFF;
		z-index: 999;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 1px 14px rgba(0, 0, 0, 0.12);
		border-radius: 12px;
		padding: 30px 0 16px;
		box-sizing: border-box;
		margin-bottom: 10px;
	}

	.code-img {
		width: 200px;
		height: 200px;
		margin-bottom: 10px;
	}

	.msg {
		display: flex;
		align-items: center;
		color: #666666;
		font-size: 14px;
		margin-bottom: 2px;
	}

	.msg.blue {
		color: #2A63F3;
	}

	.btn {
		color: #FFFFFF;
		font-size: 16px;
		background-color: #2A63F3;
		border-radius: 100px;
		width: 155px;
		height: 38px;
		line-height: 38px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 10px;
	}

	.icon {
		width: 16px;
		margin-right: 2px;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 100;
		background: rgba(0, 0, 0, 0.5);
	}

	.window {
		width: calc(100% - 70px);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		background-color: #FFFFFF;
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 20px 20px 30px;
		box-sizing: border-box;
		z-index: 150;
	}

	.window-title {
		color: #222222;
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 25px;
	}

	.window-msg {
		color: #222222;
		font-size: 14px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		align-items: center;
		margin-top: 25px;
	}

	.window-btn-box>button {
		flex: 1;
		height: 36px;
		line-height: 36px;
		background-color: #2A63F3;
		border-radius: 50px;
		color: #FFFFFF;
		font-size: 14px;
		font-weight: bold;
		margin-right: 25px;
		box-sizing: border-box;
	}

	.window-btn-box>button:last-child {
		margin-right: 0;
	}

	.window-btn-box>button.border-btn {
		border: 1px solid #979797;
		color: #222222;
		background-color: #FFFFFF;
	}
</style>
